import { Button } from '@vinted/web-ui'
import { omit } from 'lodash'

import { ConversationActionPrimaryDto } from 'types/dtos/conversation'

type Props = ConversationActionPrimaryDto & Partial<ComponentProps<typeof Button>>

const ActionButton = (props: Props) => {
  const getActionButtonStyle = props.primary ? Button.Styling.Filled : undefined

  const buttonProps: ComponentProps<typeof Button> = omit(props, 'primary')

  return (
    <Button
      {...buttonProps}
      size={props.size || Button.Size.Small}
      styling={getActionButtonStyle}
    />
  )
}

export default ActionButton
